<template>
	<v-container align-center class="d-flex" pa-0>
		<v-btn icon color="indigo" v-on:click="action()" class="mr-1">
			<v-icon>mdi-keyboard-backspace</v-icon>
		</v-btn>
		<span class="body-2">{{title}}</span>
	</v-container>
</template>

<script>
	export default {
		props: {
			title: String,
			action: Function
		}
	}
</script>

<style scoped>
	.container {
		background-color: #efefef;
	}
</style>